import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';

@Injectable()
export class InfoListOcurrenceService {

  constructor(private conService: ApiConService) { }

  async getListaOcorrencias() 
  {
    try 
    {
      const response = await this.conService.patch('DCOcorrencias');

      console.log('response------------------------------');
      console.log(response);

      return response[0];
    }catch (Error) {
      console.log("CATCH________getListaOcorrencias");
      console.log(Error);
    }
  }

}
